// extracted by mini-css-extract-plugin
module.exports = {"card":"CardWithIconLink_card__3N16P","cardIcon":"CardWithIconLink_cardIcon__1jheN","linkLabel":"CardWithIconLink_linkLabel__1BkBg"};